import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const ClientsUrl = `${Base_Url}/Client`;

export const GetClientList = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Parties/GetPartiesList`,
    params
  );
  return res;
};
export const UpdateTenderStatus = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Parties/ChangeTenderStatus`,
    params
  );
  return res;
};

export const GetChangeTenderStatus = async (PartiesKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Parties/GetChangeTenderStatus?PartiesKeyID=${PartiesKeyID}`);
  return res;
};

export const AddUpdateClient = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Parties/AddUpdateParties`,
    params
  );
  return res;
};

export const GetClientModel = async (PartiesKeyID) => {

  const res = await getApiWithAuthorization(
    `${Base_Url}/Parties/GetPartiesModel?PartiesKeyID=${PartiesKeyID}`
  );
  return res;
};

export const ChangeClientStatus = async (partiesKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Parties/ChangePartiesStatus?PartiesKeyID=${partiesKeyID}`
  );
  return res;
};

export const DeleteClient = async (ModuleName, KeyID, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${ClientsUrl}/DeleteClient?ModuleName=${ModuleName}&ClientKeyID=${KeyID}&UserKeyID=${UserKeyID}`
  );
  return res;
};

export const GetClientProjectLookupList = async (UserKeyID, ClientKeyID) => {
  const res = await getApiWithAuthorization(
    `${ClientsUrl}/GetClientProjectLookupList?UserKeyID=${UserKeyID}&ClientKeyID=${ClientKeyID}`
  );
  return res;
};

export const GetClientProjectLookupListReport = async (
  ModuleName,
  UserKeyID
) => {
  const res = await getApiWithAuthorization(
    `${ClientsUrl}/GetClientProjectLookupList?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}`
  );
  return res;
};

export const GetClientDetails = async (UserKeyID, ClientKeyID) => {
  const res = await getApiWithAuthorization(
    `${ClientsUrl}/GetClientDetails?UserKeyID=${UserKeyID}&ClientKeyID=${ClientKeyID}`
  );
  return res;
};
export const GetClientLookupList = async (ModuleName, KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Parties/GetClientLookupList`
  );
  return res;
};

export const GetVendorLookupList = async (ModuleName, KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Parties/GetClientLookupList?Type=Vendor`
  );
  return res;
};
export const GetTenderLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Parties/GetTenderLookupList`
  );
  return res;
};

export const clientDetails = async (PartiesKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Parties/GetPartiesDetail?PartiesKeyID=${PartiesKeyID}`
  );
  return res;
}



export const GetTenderTypeLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/TenderType/GetTenderTypeLookupList`
  );
  return res;
};